module.exports = __webpack_public_path__ + "img/mit1.e0de5e22.png";